import { render, staticRenderFns } from "./reportQuerySummaryDetail.vue?vue&type=template&id=596acdb4&scoped=true"
import script from "./reportQuerySummaryDetail.vue?vue&type=script&lang=js"
export * from "./reportQuerySummaryDetail.vue?vue&type=script&lang=js"
import style0 from "./reportQuerySummaryDetail.vue?vue&type=style&index=0&id=596acdb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596acdb4",
  null
  
)

export default component.exports